import Section from '@lyra/core/components/Section'
import useOrderbook from '@lyra/web/hooks/useOrderbook'
import useTicker from '@lyra/web/hooks/useTicker'
import { parseInstrumentName } from '@lyra/web/utils/instruments'
import { OrderbookGroup } from '@lyra/web/utils/orderbook'
import { useState } from 'react'
import { StackProps } from 'tamagui'

import OrderbookTable from './OrderbookTable'

type Props = {
  instrumentName: string
  numTicks?: number
  selectedLimitPrice?: number
  onPressTick?: (limitPrice: number) => void
} & StackProps

const Orderbook = ({
  instrumentName,
  numTicks,
  selectedLimitPrice,
  onPressTick,
  ...stackProps
}: Props) => {
  const [tickGroup, setTickGroup] = useState<OrderbookGroup>(1)
  const orderbook = useOrderbook(instrumentName, tickGroup)
  const ticker = useTicker(instrumentName)
  const marketId = parseInstrumentName(instrumentName)?.marketId

  return orderbook && ticker && marketId ? (
    <OrderbookTable
      numTicks={numTicks}
      currencyId={marketId}
      tickGroup={tickGroup}
      ticker={ticker}
      orderbook={orderbook}
      selectedLimitPrice={selectedLimitPrice}
      onChangeTickGroup={setTickGroup}
      onPressTick={onPressTick}
      {...stackProps}
    />
  ) : (
    <Section.Spinner {...stackProps} />
  )
}

export default Orderbook
